import React, { useState } from "react";
import Popover from "./Popover";
import Icon from "./Icon";

// A filter button with a checklist of options and their counts.
// Long lists get a search box at the top.
export default function MultiSelect({ label, options, selected, onChange }) {
  const [query, setQuery] = useState("");
  const chosen = new Set(selected.map((v) => v.toLowerCase()));

  const toggle = (value) => {
    const key = value.toLowerCase();
    onChange(
      chosen.has(key) ? selected.filter((v) => v.toLowerCase() !== key) : [...selected, value]
    );
  };

  const visible = query
    ? options.filter((o) => o.value.toLowerCase().includes(query.toLowerCase()))
    : options;

  return (
    <Popover
      triggerClass={`filter-btn${selected.length ? " is-active" : ""}`}
      trigger={
        <>
          {label}
          {selected.length > 0 && <span className="filter-count">{selected.length}</span>}
          <Icon name="chevron" size={14} />
        </>
      }
    >
      <div className="ms">
        {options.length > 8 && (
          <input
            className="ms-search"
            placeholder={`Search ${label.toLowerCase()}`}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            autoFocus
          />
        )}
        <div className="ms-list">
          {visible.length === 0 && <div className="ms-empty">No matches</div>}
          {visible.map((o) => (
            <label key={o.value} className={`ms-item${o.count === 0 ? " is-zero" : ""}`}>
              <input
                type="checkbox"
                checked={chosen.has(o.value.toLowerCase())}
                onChange={() => toggle(o.value)}
              />
              <span className="ms-value">{o.value}</span>
              <span className="ms-n">{o.count}</span>
            </label>
          ))}
        </div>
        {selected.length > 0 && (
          <button type="button" className="ms-clear" onClick={() => onChange([])}>
            Clear {label.toLowerCase()}
          </button>
        )}
      </div>
    </Popover>
  );
}
